<template>
  <div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 BU Page</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block -->
    <div class="block my-5">
      <div class="form-item d-flex align-center">
        <label class="w-240px py-5"><h4>BU Name</h4></label>
        <div class="flex-grow-1 pt-5">
          <v-text-field
            v-model="bu.name"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <div class="form-item d-flex">
        <div class="py-5">
          <label><h4 class="w-240px  mb-10px">Order</h4></label>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="mt-10px" style="width: 248px">
          <v-text-field
            v-model="bu.order"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <div class="form-item py-5 d-flex">
        <h4 class="w-240px flex-shrink-0">Sections</h4>
        <div class="d-flex flex-wrap">
          <div
            v-for="section in sections"
            :key="section.name"
            class="w-220px mb-2"
          >
            <v-checkbox v-model="section.isChecked">
              <template v-slot:label>
                <div class="h5 ink-01-emphasis--text">
                  {{ section.name }}
                </div>
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
    </div>
    <!-- block -->
    <div class="block" v-if="isCheckedSections.length > 0">
      <PageMenu :sections="isCheckedSections">
        <component :is="filterSectonsView" :bu="bu"></component>
      </PageMenu>
    </div>
    <!-- page-actions -->
    <div class="page-actions" v-if="isCheckedSections.length > 0">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageMenu from '@/components/PageMenu.vue';
import BUMessaging from '@/views/B-3__BUPage/c/B-3-2-1__BUPageEdit_BUMessage.vue';
import NewsBannerVideo from '@/views/B-3__BUPage/c/B-3-2-2__BUPageEdit_Sec-NewsBanner+Video.vue';
import ProductCategory from '@/views/B-3__BUPage/c/B-3-2-3__BUPageEdit_Sec-ProductCategory.vue';
import TeamSponsorship from '@/views/B-3__BUPage/c/B-3-2-4__BUPageEdit_TeamSponsorship.vue';
import VideoRotate from '@/views/B-3__BUPage/c/B-3-2-5__BUPageEdit_Sec-VideoRotate.vue';
import TechnologyHighlight from '@/views/B-3__BUPage/c/B-3-2-6__BUPageEdit_TechnologyHighlight.vue';
import Application from '@/views/B-3__BUPage/c/B-3-2-7__BUPageEdit_Application.vue';
import QuikTips from '@/views/B-3__BUPage/c/B-3-2-8__BUPageEdit_Sec-Quicktips.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';
import NewsandEvents from '@/views/B-3__BUPage/c/B-3-2-9__BUPageEdit_NewsandEvents.vue';

export default {
  components: {
    PageMenu,
    BUMessaging,
    NewsBannerVideo,
    ProductCategory,
    TeamSponsorship,
    VideoRotate,
    TechnologyHighlight,
    Application,
    QuikTips,
    LangDialog,
    NewsandEvents,
  },
  data: () => ({
    isLangOpen: false,
    sections: [],
  }),
  async created() {
    await this.getBuSections()
      .then((data) => {
        this.sections = data.map(
          (item) => {
            item.name = item.title;
            item.component = item.title.replace(/\+|\s/g, '');
            if (this.bu.sections) {
              item.isChecked = this.bu.sections.indexOf(item.id) !== -1;
            }
            return item;
          },
        );
      });
  },
  computed: {
    ...mapState(['lang']),
    ...mapState('bupage', ['bu']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
    isCheckedSections() {
      const vm = this;
      return vm.sections.filter((section) => section.isChecked);
    },
    isCheckedSectionData() {
      const vm = this;
      return vm.sections.filter((section) => section.isChecked).map((section) => section.id);
    },
    filterSectonsView() {
      const vm = this;

      // avoid active not checked section view
      // ex: unchecked QuickTips checkbox, section QuickTips should disappear
      if (vm.isCheckedSections.length === Number(vm.sectionIndex)) {
        vm.$router.replace({ query: { section: '0' } });
      }

      return vm.isCheckedSections[vm.sectionIndex].component;
    },
  },
  methods: {
    ...mapActions('bupage', {
      clear: 'clear',
      save: 'save',
      getBuSections: 'sections',
    }),
    cancelHandler() {
      this.clear();
      this.$router.push({ name: 'BUPage' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.bu.sections = this.isCheckedSectionData;
        this.save(this.bu).then(() => {
          this.$router.push({ name: 'BUPage' });
          this.clear();
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
